/**
 * Procedure Categories and Procedures for Diploma in Anaesthesia students
 */
export const DIPLOMA_ANAESTHESIA_PROCEDURES = {
  "Airway & Ventilation": [
    "Blind Nasal Intubation",
    "Failed Intubation Drill (includes Fiberoptic Laryngo/Bronchoscope)",
    "Double Lumen Tube Insertion",
    "Jet Ventilation",
    "Intubation in Neonates",
    "Topical Airway Anaesthesia for Awake Intubation",
    "Suctioning and Physiotherapy of Wet Lung",
    "Initiation and Management of Ventilation",
  ],
  "General & Neuraxial Anaesthesia": [
    "Administration of General Anaesthesia (ASA I to V)",
    "Subarachnoid Block (Spinal Block)",
    "Combined Spinal Epidural Block",
    "Extradural Block (EDB) - Lumbar and Thoracic",
    "Caudal Block (Adult and Pediatric)",
    "Epidural Steroid Injection (All Levels) and Long-term Epidural Catheterization",
  ],
  "Peripheral & Regional Nerve Blocks": [
    "Brachial Plexus Block",
    "Cervical Plexus Block",
    "Intravenous Regional Anaesthesia (Bier's Block)",
    "Peripheral Nerve Block - Elbow",
    "Peripheral Nerve Block - Wrist",
    "Peripheral Nerve Block - Digital",
    "Peripheral Nerve Block - Sciatic",
    "Peripheral Nerve Block - Femoral",
    "Peripheral Nerve Block - Lateral Cutaneous Nerve of Thigh",
    "Peripheral Nerve Block - Ankle",
    "Peripheral Nerve Block - Popliteal",
    "Peripheral Nerve Block - Trigeminal",
    "Peripheral Nerve Block - Retrobulbar",
    "Peripheral Nerve Block - Paravertebral",
    "Peripheral Nerve Block - Intercostal",
    "Peripheral Nerve Block - Infra-orbital",
    "3 in 1 Block",
  ],
  "Sympathetic & Pain Management Blocks": [
    "Cervical Block - Superficial and Deep",
    "Stellate Ganglion Block",
    "Splanchnic Block",
    "Lumbar Sympathetic Block",
    "Celiac Plexus Block",
  ],
  "Vascular Access & Invasive Monitoring": [
    "Central Venous Line by Brachial Vein",
    "Central Venous Line by Jugular Vein",
    "Central Venous Line by Subclavian Vein",
    "Radial Artery Cannulation",
    "Femoral Artery Cannulation",
    "CVP Monitoring",
    "Neuro-muscular Transmission Monitoring",
    "Anaesthetic Depth Monitoring (e.g. BIS Monitoring)",
  ],
  "Interventional Procedures": [
    "Lumbar Puncture and CSF Drainage",
  ],
};

export const DIPLOMA_ANAESTHESIA_CATEGORIES = Object.keys(DIPLOMA_ANAESTHESIA_PROCEDURES);

export const isDiplomaInAnaesthesiaDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("diploma") && d.includes("anaesthesia");
};
